import { specialtyColor } from 'foundations-theming-specialty/utils';
// @ts-expect-error - no TypeScript definitions available
import * as RespondentTypes from './respondentTypes';
export const RespondentTypeColorTokens = {
  [RespondentTypes.DETRACTOR]: specialtyColor('reporting-fill-chart-default-light-pink'),
  [RespondentTypes.PASSIVE]: specialtyColor('reporting-fill-chart-default-light-orange'),
  [RespondentTypes.PROMOTER]: specialtyColor('reporting-fill-chart-default-light-green')
};